/* f24-descargas.js — descarga real de los PDFs + segunda capa del guardia.
 *
 * DESCARGA: el CDN de Shopify manda `access-control-allow-origin: *`
 * (verificado sobre los 4 catálogos), así que se puede hacer fetch → blob →
 * <a download> desde ferre24.com.mx. Es la única forma de que el archivo se
 * BAJE en vez de abrirse en el visor: el atributo `download` de un <a> se
 * ignora cuando el href es de otro origen, y el CDN no manda
 * Content-Disposition: attachment.
 *
 * GUARDIA: el guardia de verdad es el de Liquid. Éste es la segunda capa,
 * porque Shopify cachea el HTML anónimo unos minutos y en esa ventana podría
 * servirse una página con un folleto ya vencido. Se REMUEVE el nodo, no se
 * oculta: ocultar deja la URL en el HTML.
 */
(function () {
  'use strict';

  var cont = document.querySelector('[data-f24-descargas]');
  if (!cont) return;

  function track(name, props) {
    props = props || {};
    try { if (window.gtag) window.gtag('event', name, props); } catch (e) {}
    try { if (window.posthog) window.posthog.capture(name, props); } catch (e) {}
  }

  /* --- Capa 2 del guardia de vigencia --- */
  Array.prototype.slice.call(cont.querySelectorAll('[data-folleto-until]')).forEach(function (el) {
    var hasta = Date.parse(el.getAttribute('data-folleto-until'));
    if (!isNaN(hasta) && Date.now() > hasta) {
      el.remove();
      track('folleto_vencido_oculto', {});
    }
  });

  function mb(n) { return (n / 1048576).toFixed(1) + ' MB'; }

  function bajar(card) {
    var url = card.getAttribute('data-url');
    var nombre = card.getAttribute('data-nombre') || 'Ferre24.pdf';
    var id = card.getAttribute('data-id') || 'doc';
    var btn = card.querySelector('[data-f24-dl-btn]');
    var st = card.querySelector('[data-f24-dl-state]');
    var t0 = Date.now();

    track('download_click', { archivo: id });
    if (btn) { btn.setAttribute('disabled', 'disabled'); }
    if (st) st.textContent = 'Descargando…';

    return fetch(url, { mode: 'cors' })
      .then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        var total = parseInt(r.headers.get('content-length') || '0', 10);
        if (!r.body || !total || !window.ReadableStream) return r.blob();
        // Progreso visible: 7 MB por datos móviles sin señal de avance se
        // siente como que la página se colgó.
        var reader = r.body.getReader(), chunks = [], leido = 0;
        return (function pump() {
          return reader.read().then(function (res) {
            if (res.done) return new Blob(chunks, { type: 'application/pdf' });
            chunks.push(res.value);
            leido += res.value.length;
            if (st) st.textContent = 'Descargando… ' + Math.round(leido / total * 100) + '%';
            return pump();
          });
        })();
      })
      .then(function (blob) {
        var u = URL.createObjectURL(blob);
        var a = document.createElement('a');
        a.href = u; a.download = nombre;
        document.body.appendChild(a); a.click(); a.remove();
        setTimeout(function () { URL.revokeObjectURL(u); }, 4000);
        if (st) st.textContent = 'Listo · ' + mb(blob.size);
        track('download_done', { archivo: id, metodo: 'blob', bytes: blob.size, ms: Date.now() - t0 });
      })
      .catch(function (e) {
        // Safari viejo, red caída, o si algún día el CDN cierra CORS.
        window.open(url, '_blank', 'noopener');
        if (st) st.textContent = 'Se abrió en otra pestaña · usa el botón de descarga del visor';
        track('download_done', { archivo: id, metodo: 'tab', error: String(e && e.message || e), ms: Date.now() - t0 });
      })
      .then(function () {
        if (btn) btn.removeAttribute('disabled');
      });
  }

  cont.addEventListener('click', function (ev) {
    var btn = ev.target.closest('[data-f24-dl-btn]');
    if (!btn) return;
    var card = btn.closest('[data-f24-dl]');
    if (card) bajar(card);
  });

  /* Los 4 de golpe: secuencial con pausa. Chrome estrangula las descargas
     programáticas simultáneas y se pierden en silencio las últimas. */
  var todos = document.querySelector('[data-f24-dl-todos]');
  if (todos) {
    todos.addEventListener('click', function () {
      var cards = Array.prototype.slice.call(cont.querySelectorAll('[data-f24-dl]'));
      todos.setAttribute('disabled', 'disabled');
      (function siguiente(i) {
        if (i >= cards.length) { todos.removeAttribute('disabled'); return; }
        bajar(cards[i]).then(function () {
          setTimeout(function () { siguiente(i + 1); }, 400);
        });
      })(0);
    });
  }

  /* Copy por perfil. Solo texto: el archivo es el mismo para los tres. */
  var perfil = new URLSearchParams(location.search).get('p') || '';
  var slot = document.querySelector('[data-f24-perfil-copy]');
  if (slot && perfil) {
    var msg = {
      agente_compras: 'Si compras por volumen, escríbenos y te armamos la lista de precios con factura.',
      instalador: 'Si instalas o revendes, escríbenos por tus precios de mayoreo y disponibilidad.',
      particular: '¿Dudas con algún equipo? Escríbenos y te decimos cuál te conviene.'
    }[perfil];
    if (msg) slot.textContent = msg;
  }
  var wa = document.querySelector('[data-f24-wa]');
  if (wa && perfil) {
    var txt = {
      agente_compras: 'Hola Ferre24, acabo de descargar el catálogo (soy agente de compras). ¿Me pasan precios por volumen y factura?',
      instalador: 'Hola Ferre24, acabo de descargar el catálogo (soy instalador). ¿Me pasan precios de mayoreo?',
      particular: 'Hola Ferre24, acabo de descargar el catálogo y tengo una duda.'
    }[perfil];
    if (txt) wa.href = wa.href.split('?')[0] + '?text=' + encodeURIComponent(txt);
  }
  if (wa) {
    wa.addEventListener('click', function () { track('whatsapp_click', { perfil: perfil || 'na' }); });
  }
})();
